import React from "react";

interface SafetyProps {
  safety: string[];
}

const Safety: React.FC<SafetyProps> = ({ safety }) => (
  <section data-section="safety" className="py-8 md:py-12">
    <div className="max-w-3xl mx-auto px-4">
      <h2 className="text-2xl font-bold text-white mb-6 text-center">Safety & Height</h2>
      <ul className="list-disc list-inside text-white/90 mb-4">
        {safety.map((item, i) => (
          <li key={i} className="mb-1">{item}</li>
        ))}
      </ul>
    </div>
  </section>
);

export default Safety;
